import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createRateCard = api(async function createRateCard({
    name,
    description,
    skillMapId,
    currency,
    defaultRate,
}) {
    return mutate(
        gql`
            mutation CreateRateCard(
                $name: String!
                $description: String
                $skillMapId: String!
                $currency: String
                $defaultRate: Float
            ) {
                createRateCard(
                    name: $name
                    description: $description
                    skillMapId: $skillMapId
                    currency: $currency
                    defaultRate: $defaultRate
                ) {
                    id
                    name
                    skillMapId
                    skillMapName
                    currency
                }
            }
        `,
        { name, description, skillMapId, currency, defaultRate },
        { returns: "createRateCard" }
    )
})
